// Create a class for the element
class ComponentEventsOverview extends HTMLElement {
  static observedAttributes = ["char"];

  constructor() {
    super();
  }

  connectedCallback() {
    this.currentFilter = this.getAttribute('char');
    this.charNav = this.querySelector('[charNav]');
    this.entries = this.querySelectorAll('.event-card');
    this.showAll = this.querySelector('[char_value="show_all"]');
    if (this.entries.length > 0 ) {
      this.updateCharFilter();
      this.filterEntries();
    }

    //display toggle
    this.displayToggles = this.querySelectorAll('[toggle]');
    this.entriesContainer = this.querySelector('.entries');
    this.displayToggles.forEach((toggle)=> {
      toggle.onclick = ()=> {
        const toggleAttribute = toggle.getAttribute('toggle');
        if(toggleAttribute == 'list'){
          this.entriesContainer.setAttribute('list_style', '');
        } else {
          this.entriesContainer.removeAttribute('list_style');
        }
      }
    })
    
    //populate city filter
    this.citySelector = this.querySelector('#city_selector');
    this.cities = new Set();

    this.entries.forEach(entry => {
        const city = entry.getAttribute('city');
        if (city) this.cities.add(city);
    });
    this.cities.forEach(city => {
        const option = document.createElement('option');
        option.value = city;
        option.innerText = city;
        this.citySelector.appendChild(option);
    });
    this.citySelector.addEventListener('change', () => {
        this.filterEntries(); // reapply filter when city changes
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if ( oldValue !== newValue ) {
      this.currentFilter = newValue;
      this.setActiveFitler(newValue)
      this.filterEntries();
    }
  }

  filterEntries(){
    let visibleCount = 0;
    const selectedCity = this.citySelector ? this.citySelector.value : 'all';
   
    this.entries.forEach(entry => {
        let hide = false;

        // month filter
        if (this.currentFilter !== 'show_all') {
            const dateAttr = entry.getAttribute('date');
            if (!dateAttr) hide = true;
            else {
                const entryDate = new Date(dateAttr);
                const entryMonthValue = `${entryDate.getFullYear()}-${entryDate.getMonth() + 1}`;
                if (entryMonthValue !== this.currentFilter) hide = true;
            }
        }

        // city filter
        if (selectedCity !== 'all') {
            const entryCity = entry.getAttribute('city');
            if (entryCity !== selectedCity) hide = true;
        }

        // apply visibility
        if (hide) entry.classList.add('hidden');
        else {
            entry.classList.remove('hidden');
            visibleCount++;
        }
    });

    
    const no_events = this.querySelector('.no-events-message');
    if (visibleCount === 0) {
        no_events.classList.remove('hidden');
    } else {
        no_events.classList.add('hidden');
    }
  }

  updateCharFilter(){
    const now = new Date();

    const months = [];
    for (let i = 0; i < 12; i++) {
        const date = new Date(now.getFullYear(), now.getMonth() + i, 1);

        const monthLabel = date.toLocaleString('default', { month: 'short', year: '2-digit' }) // Jan 26, Feb 26, etc.
        const monthValue = `${date.getFullYear()}-${date.getMonth() + 1}`; // e.g. 2026-3

        months.push({
            label: monthLabel,
            value: monthValue
        });
    }


    for (let month of months) {
        const btn = document.createElement("button");

        btn.classList.add("char");
        btn.setAttribute("char_value", month.value);
        btn.innerHTML = month.label;

        if (month.value === this.getAttribute('char')) {
        btn.classList.add("active");
        }

        btn.addEventListener("click", () => {
        this.setAttribute('char', month.value);
        });

        this.charNav.appendChild(btn);
    }

    // show all button
    if (this.showAll) {
        this.showAll.onclick = () => {
        this.setAttribute('char', 'show_all');
        };
    }
  }
  setActiveFitler( char ) {
      this.querySelectorAll('#char_list button').forEach( button => {
          if ( button.getAttribute('char_value') === char ) {
              button.classList.add('active')
          } else {
              button.classList.remove('active');
          }
      })
  }
}

customElements.define("component-events-overview", ComponentEventsOverview);
